import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatTableModule } from '@angular/material/table';
import { TranslateModule } from '@ngx-translate/core';
import { NewApplication } from '../../../services/dashboard.interface';
import { Router } from '@angular/router';

@Component({
  selector: 'app-latest-applications',
  imports: [CommonModule, MatCardModule, MatTableModule, TranslateModule],
  templateUrl: './latest-applications.html',
  styleUrl: './latest-applications.css',
})
export class LatestApplicationsComponent {
  @Input() newApplications: NewApplication[] = [];
  @Input() title: string = 'Последние заявки';

  displayedColumns: string[] = ['index', 'companyName', 'createdAt'];

  constructor(private router: Router) {}

  onRowClick(application: NewApplication): void {
    this.router.navigate(['/admin/applications/register']);
  }

  formatDate(dateStr: string): string {
    // Формат: "DD.MM.YYYY HH:mm:ss" -> "DD.MM.YYYY"
    return dateStr.split(' ')[0];
  }
}
